/** Normalize admin status from API/DB to display form values (Active | Inactive). */
export const normalizeAdminStatus = (status) => {
  const value = (status ?? 'Active').toString().trim().toLowerCase();
  return value === 'active' ? 'Active' : 'Inactive';
};
